export { default as config } from './config'
export { default as example } from './example'
export { default as router } from './router'
export { default as schedule } from './schedule'
export { default as lotteries } from './lotteries'
export { default as eventticker } from './eventticker'
export { default as structure } from './structure'
export { default as sportradar } from './sportradar'
export { default as feedfilter } from './feedfilter'
export { default as stories } from './stories';
export { firebaseReducer as firebase } from 'react-redux-firebase'
export { firestoreReducer as firestore } from 'redux-firestore'
export { sports as rmg_sports, markets as rmg_markets, categories as rmg_categories, events as rmg_events, tournaments as rmg_tournaments } from './rmg';
//export { structure as canvas_structure, results as canvas_results, toplists as canvas_toplists} from './canvas';

//export {canvas.structure as canvas_structure};